export default "__VITE_ASSET__a3afa541__"